<div [class]="'mobile-side-menu sidebar'+(showContactOverlay?' contact-overlay-open':'')" [@slideInOut]="mobileSideMenuState" smartlook-safe>
  <app-nav-menu smartlook-safe [showContactOverlay]="showContactOverlay" (showContactOverlayChange)="showContactOverlayChanged($event)"></app-nav-menu>
</div>
<div class="mobile-side-menu-mask" (click)="close()" [@fadeInOut]="mobileSideMenuMaskState"></div>
